export const userConstants = {
 
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
 
    LOGOUT: 'USERS_LOGOUT',
    LOGOUT_SUCCESS: 'USERS_LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'USERS_LOGOUT_FAILURE',
 
    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    GET_USER_REQUEST: 'USER_GET_REQUEST',
    GET_USER_SUCCESS: 'USER_GET_SUCCESS',
    GET_USER_FAILURE: 'USER_GET_FAILURE',

    MESSAGE_POST_DONE: 'MESSAGE_POST_DONE',
    
    LIST_SUPERADMIN_REQUEST: 'LIST_SUPERADMIN_REQUEST',
    LIST_SUPERADMIN_SUCCESS: 'LIST_SUPERADMIN_SUCCESS',
    LIST_SUPERADMIN_FAILURE: 'LIST_SUPERADMIN_FAILURE',

    USER_STATUS_REQUEST: 'USER_STATUS_REQUEST',
    USER_STATUS_SUCCESS: 'USER_STATUS_SUCCESS',
    USER_STATUS_FAILURE: 'USER_STATUS_FAILURE',

    POST_DATA_REQUEST: 'POST_DATA_REQUEST',
    POST_DATA_SUCCESS: 'POST_DATA_SUCCESS',
    POST_DATA_FAILURE: 'POST_DATA_FAILURE',

    GET_USER_REQUEST: 'GET_USER_REQUEST',
    GET_USER_SUCCESS: 'GET_USER_SUCCESS',
    GET_USER_FAILURE: 'GET_USER_FAILURE',
   
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/userConstants.js